// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-icon-edit-outline[data-v-3c694230] {\n  margin-right: 10px;\n}\n.el-icon-delete[data-v-3c694230] {\nspan {\n    margin-left: 4px;\n}\n}\n.customer-director[data-v-3c694230] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n.el-icon-thumb {\n    margin-left: 10px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
